module.exports = __webpack_public_path__ + "img/web.66fef0ea.png";